











































import Vue from 'vue';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import JdhFieldStructure from "@/design-system/forms/shared/JdhFieldStructure.vue"
import JdhInputArea from "@/design-system/forms/shared/JdhInputArea.vue"
import {mixins} from "vue-class-component"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import AutoNumeric from "autonumeric"
import JdhValidationProvider from "@/design-system/forms/fields/JdhValidationProvider.vue"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"
import JdhErrorMessage from "@/design-system/forms/fields/JdhErrorMessage.vue"
import FormFieldMixin from "@/design-system/forms/shared/FormFieldMixin"


/**
 * @status stable
 * @published 5.0.0
 * @changelog 5.0.0 Published with form revamp.
 * @changelog 5.9.9 Add placeholder prop.
 * @changelog 6.8.8 Add disabled prop.
 */
@Component({
    components: {
        JdhErrorMessage,
        JdhHeightTransition, JdhValidationProvider, JdhInputArea, JdhFieldStructure}
})
export default class JdsTextField extends mixins(UniqueIdMixin, FormFieldMixin) {

    @Prop() label!: string
    @Prop() value!: string
    @Prop({default: null}) width!: number
    @Prop({default: 'text', type: String}) type!: 'text'|'number'|'email'|'url'
    @Prop({default: ''}) placeholder!: string
    @Prop({type: Boolean, default: false}) disabled!: boolean

    @Prop({type: Boolean, default: false}) allowLogging!: boolean

    @Prop({type: Boolean, default: false}) required!: boolean
    @Prop({default: false}) maxLength!: string
    @Prop({default: false}) minLength!: string
    @Prop({default: false}) max!: string
    @Prop({default: false}) min!: string
    @Prop({default: null}) deny!: Array<string>
    @Prop() pattern!: string

    focus = false
    autoNumeric = null

    @Ref() inputEl!: HTMLElement

    get rules () {
        return {
            ... (this.required && {required: { allowFalse: false }}),
            ... (this.maxLength && {max_length: this.maxLength}),
            ... (this.minLength && {min_length: this.minLength}),
            ... (this.type === 'number' && {numeric: true}),
            ... (this.type === 'number' && this.max && {max: this.max}),
            ... (this.type === 'number' && this.min && {min: this.min}),
            ... (this.type === 'email' && {email: true}),
            ... (this.type === 'url' && {url: true}),
            ... (this.deny && {deny: this.deny}),

            ... (this.pattern && {pattern: this.pattern}),
        }
    }

    get inputType() {
        switch (this.type) {
            case 'number':
                return 'number'
            default:
                return 'text'
        }
    }

    get inputMode() {
        switch(this.type) {
            case 'number': return 'numeric'
            case 'email': return 'email'
            case 'url': return 'url'
            default: return 'text'
        }
    }

    mounted () {
    }

    handleBlur() {
        this.$emit('blur')
        this.coerce()
    }

    coerce() {
        if (!this.value) return false
        if (this.type === 'url' && this.value.substr(0,4) !== 'http') {
            this.$emit('input', 'https://' + this.value)
        }
    }

    emitInput(value: string) {
            this.$emit('input', value)
    }
}
